import { Dispatch, SetStateAction, useCallback, useState } from 'react';

interface UseEmojiStateReturn {
  openEmoji: boolean;
  selectedMesaage: string | null;
  emojiLoading: boolean;
  setOpenEmoji: Dispatch<SetStateAction<boolean>>;
  setSelectedMessage: Dispatch<SetStateAction<string | null>>;
  setEmojiLoading: Dispatch<SetStateAction<boolean>>;
  closeEmojiDropdown: () => void;
  handleOpenChange: (itemId: string) => void;
}

export const useEmojiState = (): UseEmojiStateReturn => {
  const [openEmoji, setOpenEmoji] = useState(false);
  const [selectedMesaage, setSelectedMessage] = useState<string | null>(null);
  const [emojiLoading, setEmojiLoading] = useState(false);

  const handleOpenChange = useCallback(
    (itemId: string) => {
      if (selectedMesaage === itemId) {
        setOpenEmoji(false);
        setSelectedMessage(null);
        return;
      }

      setOpenEmoji(true);
      setSelectedMessage(itemId);
    },
    [selectedMesaage]
  );

  const closeEmojiDropdown = useCallback(() => {
    setOpenEmoji(false);
    setSelectedMessage(null);
  }, []);

  return {
    openEmoji,
    selectedMesaage,
    emojiLoading,
    setOpenEmoji,
    setSelectedMessage,
    setEmojiLoading,
    closeEmojiDropdown,
    handleOpenChange
  };
};

export default useEmojiState;
